import React, { Fragment, useContext } from 'react';
import { Col, Container, Row } from 'reactstrap';
import CustomizerContext from '../../_helper/Customizer';

const Breadcrumbs = (props) => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <Fragment>
      <Container fluid={true}>
        <div className='page-title'>
          <Row>
            <Col xs='12'>
              <h3>{props.mainTitle}</h3>
            </Col>
            {/* <Col xs='6'>
              <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                    <SvgIcon iconId='stroke-home' />
                  </Link>
                </li>
                <li className='breadcrumb-item'>{props.parent}</li>
                {props.subParent ? <li className='breadcrumb-item'>{props.subParent}</li> : ''}
                <li className='breadcrumb-item active'>{props.title}</li>
              </ol>
            </Col> */}
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
